<template>
  <div class="fe-period-filter">
    <div class="fe-period-filter__type">
      <span class="fe-filter-bar__label">周期类型</span>
      <el-radio-group v-model="innerPeriodType" size="small" @change="handleTypeChange">
        <el-radio-button label="month">按月</el-radio-button>
        <el-radio-button label="semester">按学期</el-radio-button>
      </el-radio-group>
    </div>
    <div class="fe-period-filter__period">
      <span class="fe-filter-bar__label">评价周期</span>
      <div class="fe-period-filter__value">
        <el-date-picker
          v-show="innerPeriodType === 'month'"
          v-model="monthValue"
          type="month"
          size="small"
          placeholder="选择月份"
          value-format="yyyyMM"
          class="fe-period-month"
          @change="handleMonthChange"
        />
        <el-select
          v-show="innerPeriodType === 'semester'"
          v-model="innerPeriodKey"
          size="small"
          placeholder="选择学期"
          class="fe-period-semester"
          filterable
          clearable
          :loading="semesterLoading"
          @change="emitChange"
        >
          <el-option
            v-for="item in semesterList"
            :key="semesterOptionId(item)"
            :label="semesterOptionName(item)"
            :value="semesterOptionId(item)"
          />
        </el-select>
      </div>
    </div>
  </div>
</template>

<script>
import { getSemesterList } from '../../api/modules/misc';
import { getCurrentMonthPeriodKey } from "@/api/fiveEducation";
import { normalizeDeptId } from "@/utils/deptCascaderProps";

export default {
  name: "FePeriodFilter",
  props: {
    periodType: {
      type: String,
      default: "month",
    },
    periodKey: {
      type: String,
      default: "",
    },
    schoolDepartmentId: {
      type: [String, Number],
      default: "",
    },
  },
  data() {
    return {
      innerPeriodType: "month",
      innerPeriodKey: getCurrentMonthPeriodKey(),
      monthValue: getCurrentMonthPeriodKey(),
      semesterList: [],
      semesterLoading: false,
    };
  },
  watch: {
    periodType: {
      immediate: true,
      handler(val) {
        this.innerPeriodType = val === "semester" ? "semester" : "month";
      },
    },
    periodKey: {
      immediate: true,
      handler(val) {
        if (!val) return;
        if (this.innerPeriodType === "month") {
          this.innerPeriodKey = val;
          this.monthValue = val;
        } else if (this.semesterList.length) {
          const keyValid = this.semesterList.some(
            (s) => this.semesterOptionId(s) === String(val)
          );
          if (keyValid) {
            this.innerPeriodKey = String(val);
          }
        }
      },
    },
    schoolDepartmentId(val) {
      if (normalizeDeptId(val) && this.innerPeriodType === "semester") {
        this.loadSemesters();
      }
    },
  },
  mounted() {
    if (!this.periodKey) {
      this.resetToCurrentMonth();
    }
    if (normalizeDeptId(this.schoolDepartmentId) && this.innerPeriodType === "semester") {
      this.loadSemesters();
    }
  },
  methods: {
    /** 重置为当前自然月 */
    resetToCurrentMonth() {
      const key = getCurrentMonthPeriodKey();
      this.innerPeriodType = "month";
      this.innerPeriodKey = key;
      this.monthValue = key;
      this.emitChange();
    },

    handleTypeChange() {
      if (this.innerPeriodType === "month") {
        this.monthValue = getCurrentMonthPeriodKey();
        this.innerPeriodKey = this.monthValue;
        this.emitChange();
      } else {
        this.innerPeriodKey = "";
        if (normalizeDeptId(this.schoolDepartmentId)) {
          this.loadSemesters();
        }
      }
    },

    handleMonthChange(val) {
      this.innerPeriodKey = val || getCurrentMonthPeriodKey();
      this.emitChange();
    },

    semesterOptionId(item) {
      const id = item.Id != null ? item.Id : item.id;
      return String(id);
    },

    semesterOptionName(item) {
      return item.SemesterName || item.semesterName || "";
    },

    /** 加载学期下拉 */
    async loadSemesters() {
      if (!this.schoolDepartmentId) return;
      this.semesterLoading = true;
      try {
        const res = await getSemesterList({ departmentId: this.schoolDepartmentId });
        // getSemesterList 已在 api.js 中 return res.data，此处 res 即 MessageModel
        if (res && res.success) {
          this.semesterList = res.response || [];
          if (this.semesterList.length) {
            const keyValid = this.semesterList.some(
              (s) => this.semesterOptionId(s) === String(this.innerPeriodKey)
            );
            if (!this.innerPeriodKey || !keyValid) {
              const current = this.semesterList.find(function (s) {
                return Number(s.IsCurrent || s.isCurrent) === 1;
              });
              const pick = current || this.semesterList[0];
              this.innerPeriodKey = this.semesterOptionId(pick);
              this.emitChange();
            }
          }
        } else {
          this.semesterList = [];
        }
      } finally {
        this.semesterLoading = false;
      }
    },

    emitChange() {
      const periodType = this.innerPeriodType;
      const periodKey = this.innerPeriodKey || (periodType === "month" ? getCurrentMonthPeriodKey() : "");
      this.$emit("update:periodType", periodType);
      this.$emit("update:periodKey", periodKey);
      this.$emit("change", { periodType: periodType, periodKey: periodKey });
    },
  },
};
</script>

<style scoped>
.fe-period-filter {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  flex-shrink: 0;
}

.fe-period-filter__type,
.fe-period-filter__period {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.fe-period-filter__value {
  width: 200px;
  flex-shrink: 0;
}

.fe-period-filter__value .fe-period-month,
.fe-period-filter__value .fe-period-semester {
  width: 100%;
}
</style>
